import React, { useContext } from 'react';
import { Container, Typography, Box, Grid, IconButton, Link } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsappIcon from '@mui/icons-material/WhatsApp';
import CameraIcon from '@mui/icons-material/Camera';
import '../styles/css/Footer.css';
import { LanguageContext } from '../App';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language, translations } = useContext(LanguageContext);
  
  return (
    <Box component="footer" className="footer">
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box className="footer-branding">
              <Box className="footer-logo">                
                <Typography variant="h6" component="h3">
                  {translations[language].footerBrand}
                </Typography>
              </Box>
              <Typography variant="body2" paragraph>
                
              </Typography>
              <Box className="footer-social">
                <IconButton color="inherit" aria-label="Facebook" component="a" href="https://facebook.com/ramipazhar" target="_blank">
                  <FacebookIcon />
                </IconButton>
                <IconButton color="inherit" aria-label="Instagram" component="a" href="https://instagram.com/ramipazhar" target="_blank">
                  <InstagramIcon />
                </IconButton>
                <IconButton color="inherit" aria-label="Twitter" component="a" href="https://wa.me/972524636767" target="_blank">
                  <WhatsappIcon />
                </IconButton>                
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" component="h3" className="footer-heading">
              {translations[language].footerLinksTitle}
            </Typography>
            <ul className="footer-links">
              {translations[language].footerLinks.map(link => (
                <li key={link.id}><Link href={link.href} color="inherit">{link.label}</Link></li>
              ))}
            </ul>
          </Grid>
          
          
        </Grid>
        
        <Box className="footer-bottom">
          <Typography variant="body2" align="center">
            &copy; {currentYear} {translations[language].footerCopyright}
          </Typography>          
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
